import { Field } from '../UI';
import { RANKING_OPTIONS, RANKING_HINTS } from './tournamentConstants';

// disabled — режим нельзя менять (уже есть сыгранные матчи): rankingMode влияет на
// места и на генерацию расписания Mexicano/BtB, поэтому после первого матча заблокирован.
// lockedHint — поясняющая подсказка под селектором в заблокированном состоянии.
const RankingModeField = ({ value, onChange, disabled = false, lockedHint }) => (
  <Field label="Таблица лидеров">
    <div style={{
      display: 'flex', borderRadius: 10, border: '1.5px solid #e5e7eb',
      overflow: 'hidden', marginBottom: 8, opacity: disabled ? 0.55 : 1,
    }}>
      {RANKING_OPTIONS.map(opt => (
        <button
          key={opt.value}
          onClick={() => !disabled && onChange(opt.value)}
          disabled={disabled}
          style={{
            flex: 1, padding: '9px', border: 'none',
            background: value === opt.value
              ? 'linear-gradient(135deg, #d97706, #b45309)'
              : '#f9fafb',
            color: value === opt.value ? '#fff' : '#374151',
            fontSize: 13, fontWeight: 700,
            cursor: disabled ? 'not-allowed' : 'pointer',
            transition: 'background 0.15s',
          }}
        >
          {opt.label}
        </button>
      ))}
    </div>
    <div style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.4 }}>
      {disabled && lockedHint ? lockedHint : (RANKING_HINTS[value] || RANKING_HINTS.POINTS)}
    </div>
  </Field>
);

export default RankingModeField;
